import { heroEquipment } from "../HeroEquipment";

export const graal = {
  heroes: {
    "Rycerz Graala": {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Rycerze Graala"].Rycerz,
      type: "Bohater",
      stats: {
        Początkowa: [4, 5, 3, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Dowódca",
        "Duży cel (wierzchem)",
        "Kawalerzysta",
        "Konny",
        "Towarzysz Graala",
      ],
      exp: 20,
      skills: [0, 2, 3, 4, 5],
    },
    "Panna Graala": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 40,
      number: 1,
      equipmentList: {
        "Tradycja Bestii": [0, 4, "Tradycja"],
        "Tradycja Niebios": [0, 4, "Tradycja"],
        "Tradycja Życia": [0, 4, "Tradycja"],
        Rumak: [55, 3],
      },
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Duży cel (wierzchem)","Kawalerzysta","Mag (Tradycja Bestii albo Tradycja Niebios albo Tradycja Życia)","Mistrz Magii","Odporność na magię (1)","Wiedza tajemna (Tradycja Bestii albo Tradycja Niebios albo Tradycja Życia)","Konny"],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    "Rycerz próby": {
      id: 2,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Rycerze Graala"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Duży cel (wierzchem)", "Kawalerzysta", "Konny", "Ślubowanie"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Rycerz królestwa": {
      id: 3,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 30,
      number: 2,
      equipmentList: heroEquipment["Rycerze Graala"].Bohaterowie,
      type: "Bohater",
      stats: {
        "Początkowa": [4,3,3,3,3,1,3,1,7],
        "Maksymalna": [5,6,6,4,4,3,6,4,9]
      },
      rules: ["Duży cel (wierzchem)", "Kawalerzysta", "Konny"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Piechur: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 15,
      equipmentList: heroEquipment["Rycerze Graala"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Chłopstwo",
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Stan niższy",
        "Żywa tarcza",
      ],
    },
    "Zbrojny": {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 7,
      equipmentList: heroEquipment["Rycerze Graala"].Zbrojny,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chłopstwo", "Ranger", "Stan niższy", "Zwiadowca"],
    },
    "Pielgrzym Graala": {
      id: 6,
      startingEquipment: ["Miecz"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Rycerze Graala"].Pielgrzym,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 4, 1, 3, 1, 10],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Fanatyk", "Furia", "Stan niższy"],
    },
    "Błędny rycerz": {
      id: 7,
      startingEquipment: ["Sztylet", "Miecz", "Rumak", "Siodło & uprząż"],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Rycerze Graala"].Błędny,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        Rumak: [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda"],
    },
    Pegaz: {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [8, 3, 0, 4, 4, 3, 4, 2, 7],
        Maksymalna: [8, 3, 0, 4, 4, 3, 4, 2, 7],
      },
      rules: ["Krzepki", "Lot", "Potwór", "Wierzchowiec", "Zwierzę"],
    },
    "Bitewny ołtarz": {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Bitewny ołtarz",
        "Duży cel",
        "Machina wojenna",
        "Strach",
        "Powóz",
      ],
    },
  },
  limit: 600,
  minModels: 3,
  maxModels: 15,
  name: "Rycerze Graala",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (1)", "Podatek", "Rozrzutność", "Zamożność"],
  mercenaries: [
    "Balistyk",
    "Gladiator",
    "Minstrel",
    "Ordynans",
    "Rycerz najemny",
    "Strażnik dróg",
    "Woźnica",
    "Zwadźca",
    "Zwiadowca",
  ],
};
